var React = require('react');

function Error (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 0C13.4 0 0 13.4 0 30 0 46.6 13.4 60 30 60 46.6 60 60 46.6 60 30 60 13.4 46.6 0 30 0Zm0 33.1c-1.8 0-3.1-1.3-3.1-3.1V17.9c0-1.3 1.3-2.7 3.1-2.7 1.8 0 3.1 1.3 3.1 2.7V30c0 1.8-1.3 3.1-3.1 3.1zm0 11.6c1.8 0 3.1-1.3 3.1-2.7 0-1.8-1.3-3.1-3.1-3.1-1.8 0-3.1 1.3-3.1 3.1 0 1.3 1.3 2.7 3.1 2.7z"}));
}

Error.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","style":{"clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","version":"1"}};

module.exports = Error;

Error.default = Error;
